import { useCallback, useMemo } from 'react';

import { useFormikContext } from 'formik';

export const useAllocationForm = () => {
    const { values } = useFormikContext();

    const totalAllocationsByMonth = useMemo(() => {
        const totals = {};
        for (const [month, allocations] of Object.entries(values)) {
            totals[month] = Object.values(allocations).reduce((acc, val) => acc + (Number(val) || 0), 0);
        }
        return totals;
    }, [values]);

    const getTotalAllocationForMonth = useCallback(
        (monthKey) => {
            return totalAllocationsByMonth[monthKey];
        },
        [totalAllocationsByMonth],
    );

    return {
        getTotalAllocationForMonth,
    };
};
